import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminProrrateoAutomaticoPage } from "@/features/admin-prorrateo-automatico/components/AdminProrrateoAutomaticoPage";
import { prorrateoAutomaticoQueryOptions } from "@/features/admin-prorrateo-automatico/hooks/use-prorrateo-automatico";

/**
 * Ruta `/admin/prorrateo-automatico` · interruptor del prorrateo automático por tipo y subtipo
 * de solicitud (Contrato Anualizado y Orden de Compra).
 */
export const Route = createFileRoute("/_authed-tw/admin/prorrateo-automatico")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminProrrateoAutomatico])
      ? queryClient.ensureQueryData(prorrateoAutomaticoQueryOptions)
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminProrrateoAutomatico]}>
      <AdminProrrateoAutomaticoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
